import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/seats/license.seats.query.gql"
import type {
  LicenseSeatUsersQuery,
  LicenseSeatUsersQueryVariables,
} from "@/v2-backoffice-client/license/seats/__types__/license.seats.query"

type Options = QueryHookOptions<
  LicenseSeatUsersQuery,
  LicenseSeatUsersQueryVariables
>

export function useLicenseSeatUsersQuery(options: Options) {
  return useQuery<LicenseSeatUsersQuery, LicenseSeatUsersQueryVariables>(
    query,
    options,
  )
}
